import { Trip_Cluster_v2 } from "../../util/tripPlanner_types";
import { addStop, lock_stop, remove_poi, remove_stop } from "../api_utils";
import { clearLayer, enlargeIcon, getStopMarker_fromStopID, shrinkIcon } from "../map/helper_functions";
import { center_map, displayStopPins, remove_POI_pins } from "../map/map_displays";
import { set_filters_display } from "../tripPlanner_scripts";
import { display_stop_popout, hide_map_loadingIcon, show_map_loadingIcon } from "../ui_utils";
import { get_stop_from_stopID, inc_interaction_counter } from "../util/helper_functions";

function handle_removeStop_click() {
    const stopID:string = this.getAttribute("stopID");
    const stopData:{stop:Trip_Cluster_v2,legIndex:number,stopIndex:number}|null = get_stop_from_stopID(stopID,window.tripPlannerCurrentTrip);
    if (stopData == null) return;
    const stop:Trip_Cluster_v2 = stopData.stop;
    const legIndex:number = stopData.legIndex;
    const stopIndex:number = stopData.stopIndex;

    show_map_loadingIcon("Removing Stop");
    $("[remove-stop]").off("click");
    $("[lock-stop]").off("click");
    remove_stop(window.tripPlannerCurrentTrip, legIndex, stopIndex, stopID).then(trip => {
        window.tripPlannerCurrentTrip = trip;
        hide_map_loadingIcon();

        if ($("#stopPopout").is(":visible") && $("#stopPopout").attr("stopid") == stopID) {
            $("#stopPopout").addClass("d-none");
            document.getElementById("stopPopout").dispatchEvent(new CustomEvent("element.hide",{bubbles:true,cancelable:true}));
        };

        document.dispatchEvent(new CustomEvent("trip.updated"));
    }).catch(e => {
        if(e == "tripDeleted") {
            window.location.reload();
        } else {
            hide_map_loadingIcon();
            $("[remove-stop]").on("click", handle_removeStop_click);
            $("[lock-stop]").on("click", handle_lockStop_click);
            console.error(e);
        };
    });
};

function handle_lockStop_click() {
    const stopID:string = this.getAttribute("stopID");

    const stopData:{stop:Trip_Cluster_v2,legIndex:number,stopIndex:number}|null = get_stop_from_stopID(stopID,window.tripPlannerCurrentTrip);
    if (stopData == null) return;
    const stop:Trip_Cluster_v2 = stopData.stop;
    const legIndex:number = stopData.legIndex;
    const stopIndex:number = stopData.stopIndex;

    show_map_loadingIcon("Locking Stop");
    $("[lock-stop]").off("click");
    $("[remove-stop]").off("click");
    const directions:any = window.tripPlannerCurrentTrip.directions;
    lock_stop(window.tripPlannerCurrentTrip, legIndex, stopIndex, stopID).then(trip => {
        trip.directions = directions;
        window.tripPlannerCurrentTrip = trip;
        hide_map_loadingIcon();

        document.dispatchEvent(new CustomEvent("trip.updated",{detail:{zoom:false}}));

        const stopPopout:JQuery<HTMLElement> = $("#stopPopout");
        if (stopPopout.attr("stopID") == stop.stopID && stopPopout.is(":visible")) {
            display_stop_popout(stop.stopID, false, false);
            stopPopout.find("[stopAddedToast]").removeClass("d-none");
            setTimeout(() => {
                stopPopout.find("[stopAddedToast]").addClass("d-none");
            },5000);
        };

        inc_interaction_counter();
    }).catch(e => {
        if (e.message == "max-stops") {
            const msg = "Start your free trial to add more stops";
            if (Number.isNaN(parseInt(window.GAsubLevel))) {
                //not signed in
                $("#signUp_cardedTrialModal").find("[signUpMsg]").html(msg);
                $("#signUp_cardedTrialModal").modal("show");

            } else {
                $("#freemium-carded-trial").find("[signUpMsg]").html(msg);
                $("#freemium-carded-trial").modal("show");
            };
            try{
                //Google Analytics signup tracking (see how many times modal has opened)
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({'event': 'showMemberSignup', 'showMemberSignupParameters':{'carded':'true', 'message' : msg, 'page':window.location.href}});
            } catch (error){
                console.error(error.message)
            };
        } else {
            console.error(e);
        };
        hide_map_loadingIcon();
        $("[lock-stop]").on("click", handle_lockStop_click);
        $("[remove-stop]").on("click", handle_removeStop_click);
    })
};

export function init_postSearch_listeners() {

    set_filters_display(window.tripPlannerCurrentTrip);
    $(".add-stop-dropdown").off("show.bs.dropdown");

    $(".add-stop-dropdown").each(function() {
        $(this).on("show.bs.dropdown", function() {
            $(".add-stop-dropdown").not(this).find('[data-bs-toggle="dropdown"]').attr("aria-expanded","false");
            $(".add-stop-dropdown").not(this).find(".dropdown-menu").removeClass("show");

        });
    });
    $(".add-stop-dropdown").on("shown.bs.dropdown", function() {
        setTimeout(() => {
            $(this).find("input[type='text']").trigger("focus");
        }, 100);
    });

    $("[remove-poi]").on("click", function() {
        const stopID:string = this.getAttribute("stopID");

        const poiID:number = parseInt(this.getAttribute("poiID"));
        if (Number.isNaN(poiID)) return;

        show_map_loadingIcon("Removing POI");

        remove_poi(stopID, poiID).then(trip => {
            const directions = window.tripPlannerCurrentTrip.directions;
            trip.directions = directions;
            window.tripPlannerCurrentTrip = trip;

            hide_map_loadingIcon();
            document.dispatchEvent(new CustomEvent("trip.html.updated"));
        }).catch(e => {
            console.error(e);
        });
    });

    $("[remove-stop]").on("click", handle_removeStop_click);
    $("[lock-stop]").on("click", handle_lockStop_click);

    $("[addStopForm]").on("submit", function(event) {
        event.preventDefault();
        const input:JQuery<HTMLInputElement> = $(this).find("input[type='text']") as JQuery<HTMLInputElement>;
        const query_type:string|null = input.attr("query_type")? input.attr("query_type"): null;
        const query_val:string|null = input.attr("query_val")? input.attr("query_val"): null;
        const query:string = input.val().toString();
        const legIndex:number = parseInt($(this).attr("leg"));
        if (Number.isNaN(legIndex)) return;

        show_map_loadingIcon("Adding Stop");
        $("[remove-stop]").off("click");
        $("[lock-stop]").off("click");
        addStop(window.tripPlannerCurrentTrip, legIndex, query, query_type, query_val).then(trip => {
            window.tripPlannerCurrentTrip = trip;
            hide_map_loadingIcon();
            document.dispatchEvent(new CustomEvent("trip.updated"));

            inc_interaction_counter();
        }).catch(e => {
            if (e.message == "max-stops") {
                const msg = "Start your free trial to add more stops";
                if (Number.isNaN(parseInt(window.GAsubLevel))) {
                    //not signed in
                    $("#signUp_cardedTrialModal").find("[signUpMsg]").html(msg);
                    $("#signUp_cardedTrialModal").modal("show");

                } else {
                    $("#freemium-carded-trial").find("[signUpMsg]").html(msg);
                    $("#freemium-carded-trial").modal("show");
                };
                try{
                    //Google Analytics signup tracking (see how many times modal has opened)
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({'event': 'showMemberSignup', 'showMemberSignupParameters':{'carded':'true', 'message' : msg, 'page':window.location.href}});
                } catch (error){
                    console.error(error.message)
                };
            } else {
                console.error(e);
            };
            hide_map_loadingIcon();
            $("[remove-stop]").on("click", handle_removeStop_click);
            $("[lock-stop]").on("click", handle_lockStop_click);
        });
    });

    $("[stop-date-display]").on("click", function() {
        const stopID:string = this.getAttribute("stopID");
        $(`[stop-date-selector][stopID="${stopID}"]`).trigger("click");
    });
    $("[stay-date-display]").on("click", function() {
        const stopID:string = this.getAttribute("stopID");
        $(`[stay-date-selector][stopID="${stopID}"]`).trigger("click");
    });

    $("[viewSuggestedStopPopout]").on("click", function(event) {
        if (
            event.target.matches('[data-bs-toggle="dropdown"]') ||
            event.target.matches('[toggle-stop-details]') ||
            event.target.matches('[stop-date-selector]') ||
            event.target.matches('[lock-stop]') ||
            event.target.matches(".ai-calendar") ||
            event.target.matches("[tieredfeature]") ||
            $(event.target).closest('[tieredfeature],[stop-date-selector],[toggle-stop-details],[data-bs-toggle="dropdown"],[lock-stop]').length > 0
        ) return;

        const stopID:string = this.getAttribute("stopID");
        display_stop_popout(stopID, true, true);
    });

    $("[viewStopPopout]").on("click", function(event) {
        if (
            event.target.matches('[data-bs-toggle="dropdown"]') ||
            event.target.matches('[toggle-stop-details]') ||
            event.target.matches('[stop-date-selector]') ||
            event.target.matches('[lock-stop]') ||
            event.target.matches(".ai-calendar") ||
            event.target.matches(".ai-reorder-dots") ||
            event.target.matches("[stop-date-display]") ||
            event.target.matches("[tieredfeature]") ||
            $(event.target).closest('[tieredfeature],[stop-date-display],[stop-date-selector],[toggle-stop-details],[data-bs-toggle="dropdown"],[lock-stop]').length > 0
        ) return;

        event.stopImmediatePropagation();

        const stopID:string = this.getAttribute("stopID");

        const tab_id:string = this.getAttribute("tab");

        if (tab_id != undefined) {
            $("#stopPopout").find(`a[href="${tab_id}"]`).tab("show");
        };

        display_stop_popout(stopID,false, false);
    });

    $(".tripOverviewStop").on("mouseenter", function() {
        const stopID:string = this.getAttribute("stopID");
        const stopMarker = getStopMarker_fromStopID(stopID);

        window.enlargedStopIcon = stopMarker;

        if (stopMarker != null) enlargeIcon(stopMarker, null);
    });
    $(".tripOverviewStop").on("mouseleave", function() {
        const stopID:string = this.getAttribute("stopID");
        const stopMarker = getStopMarker_fromStopID(stopID);

        window.enlargedStopIcon = undefined;

        if (stopMarker != null) shrinkIcon(stopMarker, null);
    });

    function stopPopout_hideHandler () {

        $("#ol_map_poi_popup_card").hide();

        $("#radius-pois").dropdown("hide");

        window.currentPOIoptions = [];

        if (!$("#map-stay-mobile").hasClass("d-none")) {
            $("#map-stay-mobile").addClass("d-none");
        };

        $("#ol_map_popup_card").hide();

        $(".tripOverviewStop").removeClass("active");

        clearLayer(window.zoomedClusterMarkerLayer_agStops);
	    clearLayer(window.zoomedClusterMarkerLayer_userStops);
        clearLayer(window.clusterMarkerLayer);
        displayStopPins(window.tripPlannerCurrentTrip);

        remove_POI_pins(true, []);
        clearLayer(window.rvShareMarkerLayer);

        center_map(window.mainTripPlannerMap, window.tripPlannerCurrentTrip);
    }

    document.getElementById("stopPopout").removeEventListener("element.hide", stopPopout_hideHandler);
    document.getElementById("stopPopout").addEventListener("element.hide", stopPopout_hideHandler);

    $("[stopDetailsTabs] a[data-bs-toggle='tab']").parent().on("click", function(event) {
        if ($(this).find("a[data-bs-toggle='tab']").hasClass("is-shown")) {
            const stopID = this.getAttribute("stopID")
            $(`a[href="#hidden-${stopID}"]`).tab("show");

            $(`[stop_drive_stats][stopID="${stopID}"]`).removeClass("d-none");
        }
    });

    $("[stopDetailsTabs] a[data-bs-toggle='tab']").on("shown.bs.tab", function() {
        const stopID:string = this.getAttribute("stopID");
        if (!this.getAttribute("href").includes("hidden")) {
            $(`[toggle-stop-details][stopID="${stopID}"]`).show();
        };

        $(`[stop_drive_stats][stopID="${stopID}"]`).addClass("d-none");

        setTimeout(() => {
            $(this).addClass("is-shown")
        }, 100);

        if (window.openStopTabIds == undefined) {
            window.openStopTabIds = [this.getAttribute("href")];
        }
        else if (!window.openStopTabIds.includes(this.getAttribute("href"))) {
            window.openStopTabIds.push(this.getAttribute("href"));
        };
    });
    $("[stopDetailsTabs] a[data-bs-toggle='tab']").on("hidden.bs.tab", function () {
        $(this).removeClass("is-shown");

        if (window.openStopTabIds != undefined) {
            const idx:number = window.openStopTabIds.indexOf(this.getAttribute("href"));
            if (idx != undefined && idx != null && idx != -1) {
                window.openStopTabIds.splice(idx, 1);
            };
        };
    });

    $("[toggle-stop-details]").on("click", function() {
        const stopID:string = this.getAttribute("stopID");
        $(`a[href="#hidden-${stopID}"]`).tab("show");
        $(this).hide();
        $(`[stop_drive_stats][stopID="${stopID}"]`).removeClass("d-none");
    });

    $("#onRouteMenu").on("click",function(event) {
        event.stopPropagation();
    })
};